// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
// Importation des styles globaux
import './styles/_variables.css';  // ⚠️ TOUJOURS EN PREMIER
import './styles/index.css';
import './styles/global.css';
import './styles/header.css';
import './styles/cart-icon.css';
import './styles/hamburger-menu.css';
import './styles/cart.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
